export default {
  logo_bg: require("./logo.png"),
  // logo:require("./LOGO.png"),
  google: require("./google.jpg"),
  phone: require("./Phone.png"),
  apple: require("./apple.png"),
  creator: require("./CREATOR.jfif"),
  img1: require("./img1.jpg"),
  img2: require("./img2.jpg"),
  img3: require("./img3.jpg"),
  img4: require("./img4.jpg"),
  ava1: require("./ava1.png"),
  ava2: require("./ava2.png"),
  ava3: require("./ava3.png"),
  burger:require("./burger.jpg"),
  qrleftmenu:require("./QR-left-menu.png"),
  footer:require("./Footer.png")
};
